import type { PropsWithChildren, ReactNode } from "react";
export function ChartCard({
  title,
  subtitle,
  action,
  children,
  className = "",
}: PropsWithChildren<{
  title: string;
  subtitle?: string;
  action?: ReactNode;
  className?: string;
}>) {
  return (
    <section className={`chart-card ${className}`}>
      <div className="card-heading">
        <div>
          <h3>{title}</h3>
          {subtitle ? <p>{subtitle}</p> : null}
        </div>
        {action}
      </div>
      <div className="chart-body">{children}</div>
    </section>
  );
}
